export const zdarCustomCiphers = {
    cones: 'cones',
    butcher: 'butcher',
    trees: 'trees',
    birds: 'birds',
};
